export default {
  customProduct: {
    CustomProduct: 'заказная продукция',
    Status: 'состояние',
    SampleFee: 'плата за образец',
    inputPlaceholder: 'поиск по наименованию продукта или номеру спроса',
    AddNewDemand: 'добавить новое требование',
    Product: 'продукт',
    AddedTime: 'дополнительное время',
    DemandStatus: 'потребное состояние',
    PaymentStatus: 'платёж',
    Action: 'действие',
    Details: 'Подробности',
    DemandNo: 'не требуется',
    More: 'больше',
    Edit: 'редактор',
    PaySampleFee: 'плата за образец',
    PaymentRecords: 'запись платежей',
    Cancel: 'Отмена',
    Unreceived: 'не получено',
    Received: 'получил',
    Completed: 'сделано',
    Canceled: 'Отмена',
    Published: 'Опубликовано',
    Unpaid: 'не оплачено',
    Paid: 'заплатить',
    CreatedTime: 'время создания',
    TransactionTime: 'время операции',
    Amount: 'количество',
    PaySampleFeeTips: 'Пожалуйста, заплатите за образец, образец заказа может быть получен после платежа',
    PaymentAmount: 'сумма платежа',
    PaymentMethod: 'форма платежа',
    CreditCard: 'кредитная карточка',
    Balance: 'равновесие',
    Confirm: 'подтверждение',
    transactionError: 'Ошибка обработки заказа',
    CustomProcess: 'заказная схема',
    stepTitle1: 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ðµ',
    stepDescription1_1: 'щелчок',
    stepDescription1_2: 'Нажмите кнопку, чтобы заполнить информацию о продукте, который необходимо настроить.',
    stepTitle2: 'связаться с нашим клиентом',
    stepDescription2: 'Наш представитель обслуживания клиентов направит вам сообщение по электронной почте для связи с вашим заказом.',
    stepTitle3: 'оплата и доставка образцов',
    stepDescription3: 'Заказчик оплачивает пробы, и "какакол" направляет образцы Заказчику для подтверждения.',
    stepTitle4: 'подтверждение образцов и официальное производство',
    stepDescription4: 'после подтверждения образца вы можете обратиться к представителю обслуживания нашего клиента и начать официальное производство.'
  },
  customDetail: {
    Back: 'назад',
    AddNewDemand: 'увеличение спроса',
    Style: 'стиль',
    ProductName: 'название',
    ProductNamePlace: 'футболка, юбка, куртка',
    ContactEmail: 'контактная почта',
    ContactEmailPlace: 'введите действительный номер электронной почты',
    PhoneNumber: 'телефонный номер',
    EstimatedOrderQuantity: 'предполагаемый количество заказа',
    EstimatedOrderQuantityPlace: 'количество заказанных изделий',
    ColorQuantity: 'количество цветов',
    ColorQuantityPlace: 'какой цвет вы хотите заказать?',
    SizeQuantity: 'размер (каждый цвет)',
    SizeQuantityPlace: 'какой размер вы хотите заказать?',
    ReferenceLinking: 'Ссылки',
    ReferenceLinkingTooltip: 'нужно настроить ссылки на продукты.',
    ReferenceLinkingPlace: 'Введите адрес ссылки',
    Description: 'описание',
    DescriptionPlace: 'Пожалуйста, сообщите нам подробную информацию о продукции, которую вы хотите заказать.',
    Image: 'образ',
    ImageTip: '(максимум 10 изображений).',
    Fabric: 'ткань',
    Category: 'категория',
    FabricName: 'наименование ткани',
    CategoryPlace: 'полотно, хлопчатобумажная ткань',
    Weight: 'вес в г',
    WeightPlace: 'вес ткани',
    Composition: 'композиция',
    Add: 'Добавить',
    Accessories: 'арматура',
    Printing: 'печать',
    PrintingType: 'тип печати',
    PrintingTypePlace: 'печать краски',
    ReferenceLinkingPlace2: 'ссылки на шаблоны',
    Width: 'ширина(cm)',
    WidthPlace: 'Ширина рисунка',
    Length: 'длина(cm)',
    LengthPlace: 'длина рисунка',
    Position: 'место',
    PositionPlace: 'печать на одежде',
    Description2: 'описание режима',
    Embroidery: 'вышивание',
    PrintingType2: 'аппликация, вышивка заплат',
    Color: 'цвет',
    Washing: 'промывать',
    WashingType: 'мойка',
    WashingTypePlace: 'мыть камень',
    PositionPlace2: 'где нужно убирать',
    OtherTechnology: 'Другие технологии',
    TechnologyName: 'техническое наименование',
    Submit: 'подчиняться',
    InputContent: 'вводное содержание',
    edit: 'редактор',
    detail: 'подробности',
    onlyPictures: 'только для загрузки изображений',
    pictureSize: 'поддержка формата: jpg, png, gif'
  },
  touristCustom: {
    SubmittedSuccessfully: 'передача успешно завершена',
    tip1: 'Нажмите ниже, чтобы связаться с сервисом клиента, чтобы сообщить ваш заказ',
    tip2: 'или терпеливо ждать вас',
    back: 'сзади',
    CustomProduct: 'заказная продукция',
    AddedTime: 'дополнительное время',
    DemandNo: 'номер спроса',
    Home: 'жилище'
  }
}

